import React from 'react';
import Modal from 'react-bootstrap-modal';

export default class SelectWarehouseModal extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            isOpen: false,
            title: "",
            warehouses: [],
            search: null,
            promiseResolve: null,
            promiseReject: null
        };
    }

    open(title, warehouses) {
        let promise = new Promise((resolve, reject) => {
            this.setState({
                isOpen: true,
                title: title,
                warehouses: warehouses,
                promiseResolve: resolve,
                promiseReject: reject
            });
        });
        return promise;
    }

    close(result) {
        if (result) {
            this.state.promiseResolve(result);
        } else {
            this.state.promiseReject();
        }
        this.setState({
            isOpen: false,
            title: "",
            warehouses: [],
            search: null,
            promiseResolve: null,
            promiseReject: null
        });
    }

    renderWarehouse(warehouse, index) {
        return (
            <tr key={"wh-row-" + index}>
                <td>{warehouse.name}</td>
                <td>{warehouse.address && warehouse.address.fullName}</td>
                <td style={{ verticalAlign: 'middle' }}>
                    <button className="calc-btn calc-btn-active" onClick={() => this.close(warehouse)}>
                        Выбрать
                    </button>
                </td>
            </tr>
        );
    }

    renderTableRows() {
        let warehouses = this.state.warehouses;
        if (this.state.search) {
            warehouses = warehouses && warehouses.filter(x => (x.name + '###' + (x.address && x.address.fullName)).toLowerCase().indexOf(this.state.search.toLowerCase()) >= 0);
        }
        return warehouses && warehouses.map((entry, index) => this.renderWarehouse(entry, index));
    }

    render() {
        return (
            <Modal show={this.state.isOpen}
                onHide={() => this.close(false)}
                aria-labelledby="ModalHeader"
                backdrop="static"
                dialogClassName="modal-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title id='ModalHeader'>
                        {this.state.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-xs-10">
                            <div className="input-group">
                                <div className="input-group-addon">
                                    <i className="glyphicon glyphicon-search"></i>
                                </div>
                                <input type="text"
                                    className="form-control"
                                    value={this.state.search ? this.state.search : ''}
                                    onChange={e => this.setState({ search: e.target.value })}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="table-responsive" style={{ marginTop: "15px" }}>
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th><b>Наименование</b></th>
                                    <th><b>Адрес</b></th>
                                    <th style={{ width: 115 }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.renderTableRows()}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Modal.Dismiss className='btn calc-btn'>
                        Отмена
					</Modal.Dismiss>
                </Modal.Footer>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./App/modals/selectWarehouseModal.jsx